/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ToolsetOrigin,
  ToolsetOrigin$Outbound,
  ToolsetOrigin$outboundSchema,
} from "./toolsetorigin.js";

export type CreateToolsetRequestBody = {
  /**
   * The slug of the environment to use as the default for the toolset
   */
  defaultEnvironmentSlug?: string | undefined;
  /**
   * Description of the toolset
   */
  description?: string | undefined;
  /**
   * The name of the toolset
   */
  name: string;
  origin?: ToolsetOrigin | undefined;
  /**
   * List of resource URNs to include in the toolset
   */
  resourceUrns?: Array<string> | undefined;
  /**
   * List of tool URNs to include in the toolset
   */
  toolUrns?: Array<string> | undefined;
};

/** @internal */
export type CreateToolsetRequestBody$Outbound = {
  default_environment_slug?: string | undefined;
  description?: string | undefined;
  name: string;
  origin?: ToolsetOrigin$Outbound | undefined;
  resource_urns?: Array<string> | undefined;
  tool_urns?: Array<string> | undefined;
};

/** @internal */
export const CreateToolsetRequestBody$outboundSchema: z.ZodMiniType<
  CreateToolsetRequestBody$Outbound,
  CreateToolsetRequestBody
> = z.pipe(
  z.object({
    defaultEnvironmentSlug: z.optional(z.string()),
    description: z.optional(z.string()),
    name: z.string(),
    origin: z.optional(ToolsetOrigin$outboundSchema),
    resourceUrns: z.optional(z.array(z.string())),
    toolUrns: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      defaultEnvironmentSlug: "default_environment_slug",
      resourceUrns: "resource_urns",
      toolUrns: "tool_urns",
    });
  }),
);

export function createToolsetRequestBodyToJSON(
  createToolsetRequestBody: CreateToolsetRequestBody,
): string {
  return JSON.stringify(
    CreateToolsetRequestBody$outboundSchema.parse(createToolsetRequestBody),
  );
}
